import { jsx as _jsx } from "react/jsx-runtime";
import { ReplacementIngredient } from "./Ingredient/ReplacementIngredient";
import { SkippedIngredient } from "./Ingredient/SkippedIngredient";
/**
 * Renders an ingredient that has undergone an automatic change due to a users lifestyle or dietary preferences. This could be either a skip, conflict, or replacement.
 * This component is designed to handle different scenarios for an ingredient's modification within a recipe due to lifestyle or dietary preferences.
 * It conditionally renders the ingredient as skipped, conflicted, or replaced based on the provided props.
 *
 * - If `skip` is true, the ingredient is rendered using the `SkippedIngredient` component, indicating it should be omitted from the recipe.
 * - Otherwise, the ingredient is considered to be replaced, and is rendered using the `ReplacementIngredient` component, displaying both the original and replacement ingredient names.
 *
 * @param {string} baseIngredientName - The name of the original ingredient subject to modification.
 * @param {string} replacementIngredientName - The name of the ingredient that replaces the original ingredient. Required if the ingredient is being replaced.
 * @param {boolean} skip- Indicates whether the ingredient should be skipped (omitted) in the recipe.
 * @param {boolean} shouldAppendComma - Determines whether a comma should be appended after the ingredient, useful for list formatting.
 */
export const LifestyleChange = ({ baseIngredientName, replacementIngredientName, skip, shouldAppendComma, inMainIngredientList, }) => {
    if (skip) {
        return (_jsx(SkippedIngredient, { ingredientName: baseIngredientName, shouldAppendComma: shouldAppendComma, inMainIngredientList: inMainIngredientList }));
    }
    else {
        return (_jsx(ReplacementIngredient, { ingredientName: baseIngredientName, shouldAppendComma: shouldAppendComma, replacementIngredient: replacementIngredientName, inMainIngredientList: inMainIngredientList }));
    }
};
